import React from 'react'
import { Link } from 'react-router-dom'
const FreeTrial = () => {
    return (
        <div className="container">
            <div className="cta-area-wrapper p-20">
                <div className="section-heading">
                    <div className="title-wrapper">
                        <h2 className="section-title has_fade_anim fs-4x  text-grad-3">
                            Start with USD 100 Free <br /> 30 Days, Zero Cost
                        </h2>
                    </div>
                    <div className="text-wrapper">
                        <p className="text has_fade_anim mt-3 fs-1 text-grad-3">
                            Create powerful virtual agents is by using intuitive no-code TruVoice platform
                        </p>
                    </div>
                    <div className="btn-wrap has_fade_anim mt-10" >
                        <Link
                            to="/sign-up" 
                            className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4 w-25"
                        >
                            <span data-text="Sign up now">Sign up now</span>
                        </Link>
                        <Link 
                            to="/contact" 
                            className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4 w-25"
                        >
                            <span data-text="Contact sales">Contact sales</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {FreeTrial}